export function useMapVariant(): "google" | "maplibre" {
  return "maplibre"
}
